// extracted by mini-css-extract-plugin
module.exports = {"split":"ClientInfo_split__1AtqG","column":"ClientInfo_column__1MO5H"};